import { graphqlUrl } from './graphqlUrl';
import axios from 'axios';

export default {
  /**
   * Создать новую транзакцию.
   *
   * @param {Number} value Значение транзакции
   * @param {Object} input
   */
  async createTransaction(value, input) {
    if (value > 0) {
      input.income = value;
      input.outcome = 0;
    } else if (value < 0) {
      input.outcome = Math.abs(value);
      input.income = 0;
    }

    return await axios.post(
      graphqlUrl,
      {
        query: `
          mutation($input: CreateTransactionInput!) {
            createTransaction(input: $input) {
              id
              user {
                id
                account
                account_bonus
                transactions {
                  id
                  income
                  outcome
                  description
                }
              }
            }
          }`,
        variables: {
          input
        }
      },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
    );
  }
};
